<template>
    <div class="activity_sign_log_list">
        <el-card>
            <div class="search-form">
                <el-input 
                    v-model="search.keyword" 
                    size="medium" 
                    placeholder="用户姓名、手机号" 
                    class="search-input"
                />
                <fuzzySelection
                    style="width: 200px"
                    size="medium"
                    ref="fuzzySelection"
                    type="4"
                    :value.sync="search.activityId"
                />
                <el-input 
                    v-model="search.exhibitorCode" 
                    size="medium" 
                    placeholder="展位号" 
                    class="search-input"
                />
                <el-select v-model="search.type" size="medium" placeholder="签到类型" class="filter-select">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option
                        :label="item.value"
                        :value="item.key"
                        v-for="(item, index) in signType"
                        :key="index"
                    />
                </el-select>
                <el-select v-model="search.exhibitionId" size="medium" placeholder="展会列表" class="filter-select">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option
                        :label="item.name"
                        :value="item.id"
                        v-for="(item, index) in exhibitionList"
                        :key="index"
                    />
                </el-select>
                <div class="date-range">
                    <label class="date-label">签到时间：</label>
                    <el-date-picker
                        v-model="timeDate"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        size="medium"
                    />
                </div>
                <div class="action-buttons">
                    <el-button size="small" @click="reset">重置</el-button>
                    <el-button type="primary" size="small" @click="subimt" :loading="!btn">
                        {{ btn ? "搜索" : "loading.." }}
                    </el-button>
                </div>
            </div>
        </el-card>
        
        <el-card style="margin-top: 10px">
            <z-table ref="table" v-model="list" @query="queryList" fullscreenLoading>
                <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
                    <el-table-column prop="id" label="ID" width="60" />
                    <el-table-column prop="userId" label="UID" width="60" />
                    <el-table-column prop="userAvatar" label="头像">
                        <template #default="{row}">
                            <p-image :src="row.userAvatar" auto />
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="姓名">
                        <template #default="{row}">
                            <p>{{ row.userRealName }}</p>
                            <p :class="row.userAuth == 1 ? 'auth-success' : 'auth-fail'">
                                {{ row.userAuth == 1 ? '已实名认证' : '未实名认证' }}
                            </p>
                            <p v-if="row.userAuth == 1">
                                ({{ getAuthTypeText(row.userAuthType) }})
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userCompany" label="公司" />
                    <el-table-column prop="userJob" label="职位" />
                    <el-table-column prop="activityName" label="活动&票种" width="280">
                        <template #default="{row}">
                            <el-tag type="info" size="mini" effect="dark" v-if="row.activityName">
                                {{ row.activityName }}
                            </el-tag>
                            <p>{{ row.ticketName }}</p>
                            <p v-if="row.category">
                                扫码备注: <el-tag>{{ row.category == 1 ? '核销' : '加出海币' }}</el-tag>
                            </p>
                            <p v-if="row.integral">
                                出海币: <el-tag :type="row.category == 1 ? 'danger' : 'success'" v-if="row.category">
                                    {{ row.category == 1 ? '-' : '+' }}{{ row.integral }}
                                </el-tag>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userRemark" label="备注">
                        <template #default="{row}">
                            <Remark
                                v-if="+row.userId"
                                :row="row"
                                url="/admin/User/editRemark"
                                rowKey="remark"
                                idKey="userId"
                                @getlist="getlist"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column prop="userOperationRemark" label="运营备注">
                        <template #default="{row}">
                            <Remark
                                v-if="+row.userId"
                                :row="row"
                                url="admin/User/editOperationRemark"
                                rowKey="operationRemark"
                                idKey="userId"
                                @getlist="getlist"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="签到信息">
                        <template #default="{row}">
                            <p>{{ row.typeName }}</p>
                            <p>{{ row.enterpriseName }}</p>
                            <p v-if="row.exhibitorCode">（展位：{{ row.exhibitorCode }}）</p>
                            <p>{{ row.createTime }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </z-table>
        </el-card>
    </div>
</template>

<script>
import list from "/src/mixin/list.js";
import fuzzySelection from "/src/components/fuzzySelection";
export default {
    mixins: [list],
    data() {
        return {
            search: {
                keyword: "",
                activityId: "",
                exhibitorCode: "",
                type: "",
              exhibitionId:""
            },
          timeDate:[],
            detail: {
                title: "加载中...",
            },
            btn: true,
            configDetail: {},

            signType: [],
          exhibitionList:[]
        };
    },

    activated() {
        // console.log(1);
    },
    components: {
        fuzzySelection,
    },
    created() {
        this.init();
    },
    methods: {
        // 获取认证类型文本
        getAuthTypeText(type) {
            const authTypes = {
                0: "身份证",
                1: "港澳通行证", 
                2: "护照"
            };
            return authTypes[type] || "未知";
        },
        
        getlist() {
            this.$refs.table.refresh();
        },
        
        reset() {
            this.search = this.$options.data.call(this).search;
            this.timeDate = this.$options.data.call(this).timeDate;
            this.getlist();
        },
        onSearch(val) {
            this.search = val;
            this.getlist();
        },
        onAdd() {
            this.$router.push({ name: "activity_speaker_ppt" });
        },
        onEdit(row) {
            this.$router.push({ name: "activity_speaker_ppt", query: { id: row.id } });
        },
        async openEntrance(done) {
            let { data: res } = await this.$http.post("/admin/ActivityPpt/close", {
                id: this.$route.query.id,
                close: this.configDetail.close == 1 ? 0 : 1,
            });
            if (res.errorCode == 200) {
                this.$message.success(res.message);
                await this.getConfigDetail();
                done();
            }
        },
        async hot({ id }, top) {
            await this.$http.post("/admin/ActivityPpt/configTop", {
                id,
                top,
            });
            this.getlist();
        },
        async init() {
            await this.getDetail();
            this.getExhibitionList()
            // this.getConfigDetail();
        },
        setUp() {
            this.$refs.Setting.init();
        },
        add({ activityId: id }) {
            this.$router.push({ name: "activity_speaker_ppt", query: { id } });
        },
        async subimt() {
            this.btn = false;
            await this.$refs.table.refresh();
            this.btn = true;
        },
        async getDetail() {
            let { data: res } = await this.$http.get("/admin/Common/getConfigDictionaries?config=activity");
            this.signType = res.data?.signType;
        },
       async   getExhibitionList(){
        let { data: res } = await this.$http.get("/admin/Exhibition/getExhibitionList", {
          params: {page:1,pageSize:100},
        });
        this.exhibitionList=res.data.list
      },
        getConfigDetail() {
            return new Promise(async (resolve, reject) => {
                try {
                    let {
                        data: { data },
                    } = await this.$http.get("/admin/ActivityPpt/getConfigDetail", {
                        params: { id: this.$route.query.id },
                    });
                    this.configDetail = {
                        ...data,
                        title: data.title || this.detail.title,
                        desc: data.desc || this.detail.desc,
                        banner: data.banner || this.detail.banner,
                    };
                    resolve(this.configDetail);
                } catch (error) {
                    reject(error);
                }
            });
        },
        async onClose({ activityId: id, close }) {
            await this.$http.post("/admin/ActivityPpt/close", { id, close: close ? 0 : 1 });
            this.getlist();
        },
        async queryList(val) {
            // console.log(this.search);
            const params = { ...val, ...this.search ,
              time:this.timeDate ? this.timeDate.join("~") : ""};
            if (params.type === "") params.type = -1;
            let { data: res } = await this.$http.get("/admin/Activity/getSignLogList", {
                params,

            });
            if (res.errorCode == 200) {
                // this.$message.success(res.message);
                // res.data.list = res.data.list.map((row) => {
                //     return {
                //         ...row,
                //         remark: row.userRemark,
                //         operationRemark: row.userOperationRemark,
                //     };
                // });

                this.$refs.table.complete(res.data);
            }
        },
        // async onDelete(row) {
        //     await this.$confirm("此操作将永久删除该, 是否继续?", "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     });
        //     let { data: res } = await this.$http.post("/admin/ActivityPpt/del", { id: row.id });
        //     if (res.errorCode == 200) {
        //         this.$message.success(res.message);
        //         this.getlist();
        //     }
        // },

        async viewRecords(done, row) {
            done();
            this.$router.push({
                name: "activity_speaker_ppt_log",
                query: {
                    id: row.id,
                },
            });
            // let { data: res } = await this.$http.post("/admin/ActivityPpt/exportExcel", {
            //     id: row.id,
            // });

            // if (res.errorCode == 200) {
            //     // this.$message.success(res.message);
            //     location.href = res.data.url;
            // }
        },
    },
};
</script>

<style lang="less" scoped>
.activity_sign_log_list {
    .search-form {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        align-items: center;
        
        .search-input {
            width: 200px;
        }
        
        .filter-select {
            width: 150px;
        }
        
        .date-range {
            display: flex;
            align-items: center;
            gap: 10px;
            
            .date-label {
                font-size: 14px;
                white-space: nowrap;
            }
        }
        
        .action-buttons {
            display: flex;
            gap: 10px;
        }
    }
    
    .auth-success {
        color: green;
    }
    
    .auth-fail {
        color: red;
    }
    
    .tag {
        display: inline-block;
        margin: 5px;
    }
}

// 响应式设计
@media (max-width: 768px) {
    .activity_sign_log_list .search-form {
        flex-direction: column;
        align-items: stretch;
        
        .search-input,
        .filter-select {
            width: 100%;
        }
    }
}
</style>
